<mat-card class="slidecontent">
<div class="taskcontainer">
  <nav class="myDrive tl-nav" [ngClass]="{ open: showmyDrive }" aria-label="Task navigation">

    <!-- Views: the two standing task queries for this record -->
    <section class="tl-section">
      <h3 class="tl-section__label">Views</h3>

      <button type="button" class="tl-item" [class.is-active]="activeView === 'all'" (click)="MyTaskFunction()">
        <mat-icon class="tl-item__icon">checklist</mat-icon>
        <span class="tl-item__text">
          <span class="tl-item__name">All tasks</span>
          <span class="tl-item__hint">Every task on this record</span>
        </span>
      </button>

      <button type="button" class="tl-item" [class.is-active]="activeView === 'office'" (click)="OfficeTasks()">
        <mat-icon class="tl-item__icon">apartment</mat-icon>
        <span class="tl-item__text">
          <span class="tl-item__name">Office tasks</span>
          <span class="tl-item__hint">Shared with your office</span>
        </span>
      </button>
    </section>

    <!-- Task lists created for this record -->
    <section class="tl-section">
      <div class="tl-section__head">
        <h3 class="tl-section__label">Task lists <span class="tl-count" *ngIf="taskLists?.length">{{ taskLists.length }}</span></h3>
        <button type="button" class="tl-add" (click)="ShowTemplateFromFolder(AddTaskListTemplate)"
          matTooltip="Create a task list from a template" matTooltipClass="tooltip">
          <mat-icon>add</mat-icon> New
        </button>
      </div>

      <div class="tl-row" *ngFor="let list of taskLists"
        [class.is-active]="activeView === 'list' && taskListID === list.taskListID">
        <button type="button" class="tl-item tl-item--list" (click)="OpenTaskList(list)"
          [matTooltip]="list.taskListName" matTooltipClass="tooltip" matTooltipShowDelay="600">
          <mat-icon class="tl-item__icon">format_list_bulleted</mat-icon>
          <span class="tl-item__text tl-item__text--grow">
            <span class="tl-item__name">{{ list.taskListName }}</span>
            <!-- completed / total by task status -->
            <span class="tl-progress" *ngIf="listProgress[list.taskListID] as p"
              [class.is-complete]="p.total && p.done === p.total" [class.is-empty]="!p.total">
              <span class="tl-progress__bar"><i [style.width.%]="listPercent(list)"></i></span>
              <span class="tl-progress__text">{{ p.total ? (p.done + ' of ' + p.total + ' complete') : 'No tasks yet' }}</span>
            </span>
          </span>
        </button>

        <button type="button" class="tl-icon-btn tl-icon-btn--send"
          *ngIf="list.isMailSent==false && list.showSendMailMenu==true" (click)="MailToAssignee(list)"
          matTooltip="Email this list to its assignees" matTooltipClass="tooltip" aria-label="Email list to assignees">
          <mat-icon>send</mat-icon>
        </button>

        <button type="button" class="tl-icon-btn" [matMenuTriggerFor]="menu" aria-label="List options">
          <mat-icon>more_vert</mat-icon>
        </button>
        <mat-menu #menu="matMenu">
          <button mat-menu-item (click)="openTaskListUrl(list)">
            <mat-icon>content_copy</mat-icon> Copy URL
          </button>
          <button mat-menu-item (click)="openTaskListUrl(list,true)">
            <mat-icon>link</mat-icon> Open external URL
          </button>
          <button mat-menu-item (click)="addEmail(list)">
            <mat-icon>mail</mat-icon> Email
          </button>
          <button *ngIf="list.showSendMailMenu==true" mat-menu-item (click)="MailToAssignee(list)">
            <mat-icon>email</mat-icon> Mail ({{ list.lastSent| date: "MM/dd/yyyy" }})
          </button>
          <button mat-menu-item (click)="updateTaskLists(updateFolderDialog,'task',list)">
            <mat-icon>edit</mat-icon> Rename
          </button>
          <button mat-menu-item (click)="ShowTemplate(Addtemplate,list)">
            <mat-icon>library_add</mat-icon> Add template
          </button>
          <button mat-menu-item (click)="SaveAsTemplate(saveAsTemplateDialog,list)">
            <mat-icon>save</mat-icon> Save as template
          </button>
          <button mat-menu-item (click)="ImportTaskTemplateFromTaskList(importTasktemplate,list)">
            <mat-icon>swap_horiz</mat-icon> Import task
          </button>
          <button mat-menu-item (click)="archivedTaskList(list)">
            <mat-icon>archive</mat-icon> Archive
          </button>
          <button mat-menu-item (click)="deleteTasklist(list)">
            <mat-icon>delete</mat-icon> Delete
          </button>
        </mat-menu>
      </div>

      <div class="tl-empty" *ngIf="!taskLists?.length">
        <p>No task lists yet.</p>
        <button type="button" class="tl-link" (click)="ShowTemplateFromFolder(AddTaskListTemplate)">
          Create one from a template
        </button>
      </div>
    </section>

    <!-- Archived lists and one-off tasks -->
    <section class="tl-section tl-section--archived">
      <button type="button" class="tl-section__toggle" (click)="showArchived = !showArchived"
        [attr.aria-expanded]="showArchived">
        <h3 class="tl-section__label">Archived</h3>
        <mat-icon>{{ showArchived ? 'expand_less' : 'expand_more' }}</mat-icon>
      </button>

      <ng-container *ngIf="showArchived">
        <ng-container *ngFor="let tasklist of taskListArchived; let i = index">
          <button type="button" class="tl-item"
            [class.is-active]="tasklist.id == 2 ? activeView === 'archivedTasks' : (currentTaskListArchived == i && taskListSelectedArchived)"
            (click)="getTaskListsArchived(tasklist,i)">
            <mat-icon class="tl-item__icon">{{ tasklist.id == 1 ? 'inventory_2' : 'task_alt' }}</mat-icon>
            <span class="tl-item__name">{{ tasklist.id == 1 ? 'Archived lists' : 'Archived one-off tasks' }}</span>
            <mat-icon class="tl-item__caret" *ngIf="tasklist.id == 1">
              {{ (currentTaskListArchived == i && taskListSelectedArchived) ? 'expand_less' : 'expand_more' }}
            </mat-icon>
          </button>

          <ng-container *ngIf="tasklist.id == 1 && i === expandedIndexArchived && taskListSelectedArchived">
            <div class="tl-row tl-row--nested" *ngFor="let list of taskListsArchived"
              [class.is-active]="activeView === 'archivedList' && taskListIDArchived === list.taskListID">
              <button type="button" class="tl-item tl-item--list" (click)="OpenTaskListArchived(list)"
                [matTooltip]="list.taskListName" matTooltipClass="tooltip" matTooltipShowDelay="600">
                <span class="tl-item__name">{{ list.taskListName }}</span>
              </button>
              <button type="button" class="tl-icon-btn" [matMenuTriggerFor]="archMenu" aria-label="Archived list options">
                <mat-icon>more_vert</mat-icon>
              </button>
              <mat-menu #archMenu="matMenu">
                <button mat-menu-item (click)="UnarchivedTaskList(list,tasklist,i)">
                  <mat-icon>unarchive</mat-icon> Unarchive
                </button>
              </mat-menu>
            </div>
            <p class="tl-empty tl-empty--nested" *ngIf="!taskListsArchived?.length">No archived lists.</p>
          </ng-container>
        </ng-container>
      </ng-container>
    </section>

  </nav>
</div>
</mat-card>


<ng-template #addFolderDialog>
 <form [formGroup]="myfolderForm"> 
 <h2 mat-dialog-title>
   <span class="groupIcon"><mat-icon>create_new_folder</mat-icon></span>
   Add {{folderTaskName}}
   <button mat-icon-button (click)="close()">
     <mat-icon>close</mat-icon>
   </button>
 </h2>

 <mat-dialog-content>  
     <mat-form-field class="">
       <mat-label>{{folderTaskName}} Name</mat-label>
       <input matInput formControlName="folderName" maxlength="100" placeholder="add name"/>
     </mat-form-field>
     <mat-form-field *ngIf="folderortask=='task'">
       <mat-label>Select Template</mat-label>
       <mat-select (selectionChange)="OnSelectTempChange($event)">
         <mat-option *ngFor="let template of TaskTemplatesList" [value]="template.taskTemplateID">
           {{ template.taskTemplateName }}
         </mat-option>
       </mat-select>
      
     </mat-form-field>
 </mat-dialog-content>
 <mat-dialog-actions align="start" fxLayout="row" fxLayoutAlign="space-between center">
   <button mat-button color="basic" (click)="close()">Cancel</button>
   <button mat-flat-button class="calltoaction" type="submit" color="primary"
   [disabled]="myfolderForm.invalid || !myfolderForm.dirty" 
   (click)="addTaskListFolder(myfolderForm.value)">
    Add
    <mat-icon *ngIf="spinner"><mat-spinner diameter="20">
    </mat-spinner></mat-icon>
  </button>
 </mat-dialog-actions>
</form>
</ng-template>

<ng-template #updateFolderDialog>
 <form [formGroup]="myfolderForm"> 
 <h2 mat-dialog-title>
   <span class="groupIcon"><mat-icon>create_new_folder</mat-icon></span>
   Update {{folderTaskName}}
   <button mat-icon-button (click)="close()">
     <mat-icon>close</mat-icon>
   </button>
 </h2>

 <mat-dialog-content>  
     <mat-form-field class="">
       <mat-label>{{folderTaskName}} Name</mat-label>
       <input matInput formControlName="folderName" maxlength="100" placeholder="update {{folderTaskName}} Name"/>
     </mat-form-field>
     
 </mat-dialog-content>
 <mat-dialog-actions align="start" fxLayout="row" fxLayoutAlign="space-between center">
   <button mat-button color="basic" (click)="close()">Cancel</button>
   <button mat-flat-button class="calltoaction" type="submit" color="primary"
   [disabled]="myfolderForm.invalid || !myfolderForm.dirty" 
   (click)="UpdateTaskListFolder(myfolderForm.value)">
    Update
    <mat-icon *ngIf="spinner"><mat-spinner diameter="20">
    </mat-spinner></mat-icon>
  </button>
 </mat-dialog-actions>
</form>
</ng-template>

<ng-template #rename>
 <h2 mat-dialog-title>
   <span class="groupIcon"><mat-icon>create_new_folder</mat-icon></span>
   Rename Folder
   <button mat-icon-button (click)="close()">
     <mat-icon>close</mat-icon>
   </button>
 </h2>
 <mat-dialog-content>
   <mat-form-field class="example-full-width">
     <mat-label>Rename</mat-label>
     <input matInput placeholder="Rename" value="Heart Surgery" />
   </mat-form-field>
 </mat-dialog-content>
 <mat-dialog-actions fxLayout="row" fxLayoutAlign="space-between center">
   <button mat-button color="">Close</button>
   <button mat-button color="primary">Save</button>
 </mat-dialog-actions>
</ng-template>



<ng-template #template>
 <h2 mat-dialog-title>
   <span class="groupIcon"><mat-icon>backup_table</mat-icon></span>
   Template Gallery
   <button mat-icon-button (click)="closeTemplate()">
     <mat-icon>close</mat-icon>
   </button>
 </h2>
 <mat-dialog-content>
   <div class="searchSelectCat">
     <div class="selectCat">
       <mat-form-field appearance="fill">
         <mat-label>Select Category</mat-label>
         <mat-select (selectionChange)="getSelectTaskCategory($event)">
           <mat-option *ngFor="let stat of taskCategoryList" [value]="stat.taskTemplateCategoryID">
               {{ stat.taskTemplateCategoryName }}
           </mat-option>
       </mat-select>
        
       </mat-form-field>
     </div> 


     <div class="search">
       <mat-form-field class="example-full-width" appearance="fill">
         <mat-label>Search</mat-label>
         <input matInput maxlength="20" placeholder="search template" (input)="searchTemplate($event.target.value)">
       </mat-form-field>
     </div>  
   </div>

   <div class="tempalteList">
     <table cellspacing="0" cellspadding="0">
       <tr>        
         <th>Template Name</th> 
         <th>Category Name</th>        
         <th class="actBtn" >Action</th>
       </tr>
       <tr>
       
         <td class="formName">
          Template 1
         </td>
         <td>Category 1</td>
         <td>          
   
           <button mat-icon-button color="primary"  mat-icon-button matTooltipClass="tooltip"
            matTooltip="Create Project"><mat-icon>post_add</mat-icon>
           </button>
           
         </td>
       </tr>
     </table>
     
   </div>
 </mat-dialog-content>
 <mat-dialog-actions fxLayout="row" fxLayoutAlign="space-between center">
   <button mat-button  color="" (click)="closeTemplate()">Close</button>   
 </mat-dialog-actions>
</ng-template>


<ng-template #MoveTo>
 <h2 mat-dialog-title>
   <span class="groupIcon"><mat-icon>note_add</mat-icon></span> 
   Move To
   <button mat-icon-button (click)="closeMoveto()">
     <mat-icon>close</mat-icon>
   </button>
 </h2>
 <mat-dialog-content>
      
     <div class="drive mainLink">              
       <div class="folderName" *ngFor="let tasklist of taskListFolderForMoveTo; let i = index">
        
         <div class="" style="display: flex; width: 100%;">

           <div class="nm" (click)="getTaskListsForMoveTo(tasklist,i)">
           
             <mat-icon class="arrow_right"  aria-hidden="true">
               chevron_right 
              </mat-icon>
                      
           <mat-icon class="type">folder</mat-icon>
           {{tasklist.taskListFolderName}}            
         </div>                 
      
         </div>
         
         <ng-container *ngIf="taskListsForMoveTo.length>0 && i === expandedIndexmoveTo">
           <ng-container *ngFor="let list of taskListsForMoveTo">
 
             <div class="subTaskList" style="margin-left:0px;margin-right:0px;"
             (click)="SelectTaskList(list)">  

               <mat-icon class="type">list</mat-icon>
               <p  [ngClass]="{ 'active': taskListIDMoveTo === list.taskListID }"> 
               {{list.taskListName}}      
              </p>

           </div>  
                     
           </ng-container>
         </ng-container>

       </div>
     </div>         
   

 </mat-dialog-content>
 <mat-dialog-actions align="start" fxLayout="row" fxLayoutAlign="space-between center">
   <button mat-button color="basic" (click)="closeMoveto()">Cancel</button>
   <button mat-flat-button class="calltoaction" type="submit" color="primary"
   [disabled]="!ButtonForMoveTo" (click)="MoveToTaskList()">
    MoveTo
    <mat-icon *ngIf="spinner"><mat-spinner diameter="20">
    </mat-spinner></mat-icon>
  </button>
 </mat-dialog-actions>

</ng-template>


<ng-template #saveAsTemplateDialog>
 <form [formGroup]="addTemplateForm"> 
 <h2 mat-dialog-title>
   <span class="groupIcon"><mat-icon>create_new_folder</mat-icon></span>
   Save As Template
   <button mat-icon-button (click)="closeSaveAsTemplate()">
     <mat-icon>close</mat-icon>
   </button>
 </h2>

 <mat-dialog-content>  

   <mat-form-field appearance="fill">
     <mat-label>Select Category</mat-label>
     <mat-select formControlName="folderID">
       <mat-option *ngFor="let stat of taskCategoryList" [value]="stat.taskTemplateCategoryID">
           {{ stat.taskTemplateCategoryName }}
       </mat-option>
   </mat-select>    
   </mat-form-field>

     <mat-form-field class="">
       <mat-label>Template Name</mat-label>
       <input matInput formControlName="taskTemplateName" maxlength="100" placeholder="add template name"/>
     </mat-form-field>

 </mat-dialog-content>
 <mat-dialog-actions align="start" fxLayout="row" fxLayoutAlign="space-between center">
   <button mat-button color="basic" (click)="closeSaveAsTemplate()">Cancel</button>
   <button mat-flat-button class="calltoaction" type="submit" color="primary"
   [disabled]="addTemplateForm.invalid || !addTemplateForm.dirty" 
   (click)="AddTaskTemplate(addTemplateForm.value)">
    Add
    <mat-icon *ngIf="spinner"><mat-spinner diameter="20">
    </mat-spinner></mat-icon>
  </button>
 </mat-dialog-actions>
</form>
</ng-template>


<ng-template #Addtemplate>
 <h2 mat-dialog-title>
   <span class="groupIcon"><mat-icon>backup_table</mat-icon></span>
   Template Gallery
   <button mat-icon-button (click)="closeTemplate()">
     <mat-icon>close</mat-icon>
   </button>
 </h2>
 <mat-dialog-content>
   <div class="searchSelectCat">
     <div class="selectCat">
       <mat-form-field appearance="fill">
         <mat-label>Select Category</mat-label>
         <mat-select (selectionChange)="getSelectTaskCategory($event)">
           <mat-option value="0">All</mat-option>
           <mat-option *ngFor="let stat of taskCategoryList" [value]="stat.taskTemplateCategoryID">
               {{ stat.taskTemplateCategoryName }}
           </mat-option>
       </mat-select>
        
       </mat-form-field>
     </div> 


     <div class="search">
       <mat-form-field class="example-full-width" appearance="fill">
         <mat-label>Search</mat-label>
         <input matInput maxlength="20" placeholder="search template" (input)="searchTemplate($event.target.value)">
       </mat-form-field>
     </div>  
   </div>

   <div class="tempalteList">
     <table cellspacing="0" cellspadding="0" *ngIf="!ShowNoRecordFoundTaskTemplates">
       <tr>        
         <th>Template Name</th> 
         <th>Category Name</th>        
         <th class="actBtn">Action</th>
       </tr>
       <tr *ngFor="let template of TaskTemplatesList" [ngClass]="{ 'active': template.taskTemplateID === taslTemplateID}">
       
         <td class="formName">
           {{template.taskTemplateName}}         
         </td>

         <td *ngIf="template.folderName==null">-</td>
         <td *ngIf="template.folderName!=null">{{template.folderName}}</td>

         <td>    
           <button mat-icon-button color="primary" mat-icon-button matTooltipClass="tooltip"
            matTooltip="Select" (click)="SelectTemplate(template)"><mat-icon>post_add</mat-icon>
           </button>            
         </td>
       </tr>
     </table>
     <div *ngIf="ShowNoRecordFoundTaskTemplates" class="noRecordFound">No Record Found</div>
   </div>
 </mat-dialog-content>

 <section class="importTo" *ngIf="taskTemplateID>0">
  <p >Would you like to import data for the newly created task-list? If so, please select the appropriate options below. If not, simply uncheck any boxes you do not wish to pull data from.</p>
  <!-- <mat-checkbox color="primary" [(ngModel)]="AttachChecked" (change)="showOptions($event,'Attach')">Attach</mat-checkbox> &nbsp; -->
  <mat-checkbox color="primary" [(ngModel)]="AssigneeChecked" (change)="showOptions($event,'Assignee')">Assignee</mat-checkbox>&nbsp;
  <!-- <mat-checkbox color="primary" [(ngModel)]="NotifyChecked" (change)="showOptions($event,'Notify')">Notify</mat-checkbox> -->
</section>

 <mat-dialog-actions fxLayout="row" fxLayoutAlign="space-between center">
   <button mat-button color="" (click)="closeTemplate()">Close</button>   

   <button *ngIf="taskTemplateID>0" mat-flat-button class="calltoaction"
     type="submit" color="primary" (click)="ImportTemplate()">
     Import     
  </button>

 </mat-dialog-actions>
</ng-template>


<ng-template #AddTaskListTemplate>
  <h2 mat-dialog-title>
    <span class="groupIcon"><mat-icon>backup_table</mat-icon></span>
    Template Gallery
    <button mat-icon-button (click)="closeTemplate()">
      <mat-icon>close</mat-icon>
    </button>
  </h2>
 <mat-dialog-content>

   

  <div class="template-holder">
    <div class="left">

      <mat-form-field appearance="fill">
        <mat-label>Select Category</mat-label>
        <mat-select (selectionChange)="onTaskListTabChange($event)" value="My Template" >
          <mat-option value="My Template">My Template</mat-option>
          <mat-option value="Organization">Organization</mat-option>
          <mat-option value="Global">Global</mat-option>
        </mat-select>
      </mat-form-field>

      

      <div class="list" #categoryList>
        <ul>
          <li (click)="getTaskListThroughCategory(0, 0)" [ngClass]="{'active': currentIndex == 0 }" >All</li>
          <ng-container  *ngFor="let stat of filteredTaskCategoryList; let i = index">
            <li (click)="getTaskListThroughCategory(stat.taskTemplateCategoryID, i+1)" [ngClass]="{'active': currentIndex == i+1 }"  > {{ stat.taskTemplateCategoryName }}</li>
          </ng-container>           
        </ul>
      
      </div>

    </div>
   <div class="right"> 
     
     <div class="searrch">
      <mat-form-field class="example-full-width" appearance="fill">
        <mat-label>Search</mat-label>
        <input matInput maxlength="20" placeholder="search template"
          (input)="searchTemplateForTaskList($event.target.value)">
      </mat-form-field>

      <mat-form-field class="">
        <mat-label>Tasklist Name</mat-label>
        <input matInput [(ngModel)]="addtaskTemplateName"  maxlength="100" placeholder="Add Tasklist Name" />
      </mat-form-field>

     </div>



     <div class="list">

      <div class="tempalteList">
        <table cellspacing="0" cellspadding="0" *ngIf="!ShowNoRecordFoundTaskTemplates">
          <tr>
            <th>Template Name</th>             
            <th class="actBtn">Action</th>
          </tr>
          <tr *ngFor="let template of FilteredTaskTemplatesList"
            [ngClass]="{ 'active': template.taskTemplateID === taslTemplateID}">

            <td class="formName">
              {{template.taskTemplateName}}
            </td>            

            <td>
              <span class="import" (click)="templateSelected(template)" >Select</span>
            </td>
          </tr>
        </table>
        <div *ngIf="ShowNoRecordFoundTaskTemplates" class="noRecordFound">No Record Found</div>
      </div>

     </div>
        
   </div>
</div>    
 </mat-dialog-content>

 <section class="importTo">
  <p>Would you like to import data for the newly created task-list? If so, please select the appropriate options below. If not, simply uncheck any boxes you do not wish to pull data from.</p>
  <!-- <mat-checkbox color="primary" [(ngModel)]="AttachChecked" (change)="showOptions($event,'Attach')">Attach</mat-checkbox> &nbsp; -->
  <mat-checkbox color="primary" [(ngModel)]="AssigneeChecked" (change)="showOptions($event,'Assignee')">Assignee</mat-checkbox>&nbsp;
  <!-- <mat-checkbox color="primary" [(ngModel)]="NotifyChecked" (change)="showOptions($event,'Notify')">Notify</mat-checkbox> -->
</section>


 <mat-dialog-actions align="start" fxLayout="row" fxLayoutAlign="space-between center">
   <button mat-button color="basic" (click)="closeTemplate()">Cancel</button>
   <button mat-flat-button class="calltoaction" type="submit" color="primary"
   [disabled]="!showAddTemp"
   (click)="SelectTemplateForTaskList()">
    Add
    <mat-icon *ngIf="spinner"><mat-spinner diameter="20">
    </mat-spinner></mat-icon>
  </button>
 </mat-dialog-actions>

</ng-template>




<ng-template #importTasktemplate>
  <h2 mat-dialog-title>
    <span class="groupIcon"><mat-icon>backup_table</mat-icon></span>
    Template Gallery

    <!-- <button mat-stroked-button color="primary" class="import" *ngIf="selectedTemplate.length>0" (click)="importTaskTemplates()">Import</button> -->

    <button mat-icon-button (click)="closeImportTaskTemplate()">
      <mat-icon>close</mat-icon>
    </button>
  </h2>
 

    <div class="template-holder">
      <div class="left">

        <mat-form-field appearance="fill">
          <mat-label>Select Category</mat-label>
          <mat-select (selectionChange)="onTaskListTabChangeForTaskImport($event)" value="My Template">
            <mat-option value="My Template">My Template</mat-option>
            <mat-option value="Organization">Organization</mat-option>           
          </mat-select>
        </mat-form-field>

        <div class="list" #categoryList>
          <ul>
            <li (click)="getTaskListThroughCategoryForTaskImport(0, 0)" [ngClass]="{'active': currentIndex == 0 }" >All</li>
            <ng-container  *ngFor="let stat of filteredTaskCategoryList; let i = index">
              <li (click)="getTaskListThroughCategoryForTaskImport(stat.taskTemplateCategoryID, i+1)" [ngClass]="{'active': currentIndex == i+1 }"  > {{ stat.taskTemplateCategoryName }}</li>
            </ng-container>           
          </ul>
        
        </div>

      </div>
     <div class="right"> 
       
      

       <div class="searrch">
        <mat-form-field class="example-full-width" appearance="fill">
          <mat-label>Search</mat-label>
          <input matInput maxlength="20" placeholder="Search Template"
            (input)="searchTemplateForSingleTask($event.target.value)">
        </mat-form-field>
       </div>
  
       

        <div class="tempalteList">
          <table cellspacing="0" cellspadding="0" *ngIf="!ShowNoRecordFoundTaskTemplates">
            <tr>
              <th> </th>
              <th>Template Name</th>             
              <th class="">&nbsp;</th>
            </tr>
            <tr *ngFor="let template of  TaskTemplatesListForSingleTask"
             [ngClass]="{ 'active': template.taskId === taskTemplateIDForSingleTask}">

             <td>
              <mat-checkbox color="primary" (change)="getCheckboxValues($event, template)">
              </mat-checkbox>
            </td> 

              <td class="formName">
                {{template.templateName}}
              </td>            

              <td>
                &nbsp;
              </td>
            </tr>
          </table>
          <div *ngIf="ShowNoRecordFoundTaskTemplates" class="noRecordFound">No Record Found</div>
        </div>

     
  
     </div>
  </div>  

  <section class="importTo" *ngIf="selectedTemplate.length>0">
    <p >Would you like to import data for the newly created task-list? If so, please select the appropriate options below. If not, simply uncheck any boxes you do not wish to pull data from.</p>
    <!-- <mat-checkbox color="primary" [(ngModel)]="AttachChecked" (change)="showOptions($event,'Attach')">Attach</mat-checkbox> &nbsp; -->
    <mat-checkbox color="primary" [(ngModel)]="AssigneeChecked" (change)="showOptions($event,'Assignee')">Assignee</mat-checkbox>&nbsp;
    <!-- <mat-checkbox color="primary" [(ngModel)]="NotifyChecked" (change)="showOptions($event,'Notify')">Notify</mat-checkbox> -->
  </section>

  <mat-dialog-actions align="start" fxLayout="row" fxLayoutAlign="space-between center">
    <button mat-button color="basic" (click)="closeImportTaskTemplate()">Cancel</button>     

    <button mat-flat-button class="calltoaction" type="submit" color="primary" *ngIf="selectedTemplate.length>0"
      (click)="importTaskTemplates()">
      Import     
    </button>
  </mat-dialog-actions> 


</ng-template>
